import {defineMessages} from 'react-intl';

export default defineMessages({
    workLocations_REMOTE: {id: 'app.pages.user.candidateRelevanceModal.workLocations.REMOTE'},
    workLocations_OFFICE: {id: 'app.pages.user.candidateRelevanceModal.workLocations.OFFICE'},
    workLocations_HYBRID: {id: 'app.pages.user.candidateRelevanceModal.workLocations.HYBRID'}
});
